import { call, put } from "redux-saga/effects";
import { setPartOffer } from "../../entities/partOffers";
import { requestGetPartOffer } from "../requests/partOffers";

export function* handleGetPartOffer(action) {
    try {
        const response = yield call(requestGetPartOffer, action.payload);
        const { data } = response;
        yield put(setPartOffer({ ...data }));
    } catch (error) {
        console.log(error);
    }
}
